import { render, staticRenderFns } from "./ContactSection.vue?vue&type=template&id=21282370&scoped=true"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"
import style0 from "./ContactSection.vue?vue&type=style&index=0&id=21282370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21282370",
  null
  
)

export default component.exports